module.exports = __webpack_public_path__ + "media/images/PadgettIcontrans-b18ea11337ff0fc14991408ab78d9fb5.png";